<template>
	<div class="body-mobile">
		<div class="wrapper-body">
			<div class="wrapper-body__header">
				<nav-step :active="3"></nav-step>
			</div>
			<div class="wrapper-body__body">
				<div class="wrapper-body__body__title">
					<p>填写信息<span>（3/4）</span></p>
				</div>
				<div class="wrapper-body__body__container"  v-if="!!form.guardian">
					<md-field v-if="form.student.applyType == 1">
						<div class="box-relation">
							<h2>关系证明</h2>
							<md-radio :name="1" v-model="form.guardian.relationType" label="申请人及其子女同一户籍的原籍户口簿" />
              <md-radio :name="2" v-model="form.guardian.relationType" label="子女父母双方的户口簿/结婚证/孩子出生医学证明或亲子鉴定 （能够证明其法定监护关系的其他有效证明）" />
              <md-radio :name="3" v-model="form.guardian.relationType" label="申请人的户口簿/被监护人的户口簿/司法部门出具其法定监护关系的证明（能够证明其法定监护关系的其他有效证明）" />
						</div>

						<md-field-item title="就业材料类型" solid>
							<md-radio :name="1" v-model="form.guardian.jobType" label="劳动合同" inline />
							<md-radio :name="2" v-model="form.guardian.jobType" label="工商营业执照" inline />
						</md-field-item>

            <!--<md-field>
              <md-input-item
                v-model="form.guardian.idCard"
                title="身份证号"
                placeholder="身份证号"
                clearable
              ></md-input-item>
            </md-field>-->

						<md-input-item
							v-show="form.guardian.jobType == 1"
							v-model="form.guardian.companyName"
							title="劳动合同所在机构"
							placeholder="请输入劳动合同所在机构"
						></md-input-item>

						<md-input-item
							v-show="form.guardian.jobType == 2"
							v-model="form.guardian.companyCode"
							title="社会统一信用代码"
							placeholder="请输入"
							:error="`申请人在`+areaName+`办理的工商营业执照（含纳税或免于纳税相关材料`"
						></md-input-item>

						<md-field-item title="社保证明" solid>
							<md-radio :name="1" v-model="form.guardian.socialSecurityProve" label="有" inline />
							<md-radio :name="0" v-model="form.guardian.socialSecurityProve" label="无" inline />
						</md-field-item>
						<div class="text-warning">
							<span>* 截止2019年5月31日，已在本市连续依法缴纳城镇职工基本养老保险满12个月的清单</span>
						</div>

						<md-field-item title="居住材料" solid>
							<md-radio :name="1" v-model="form.guardian.proofType" label="有" inline />
							<md-radio :name="2" v-model="form.guardian.proofType" label="无" inline />
						</md-field-item>

					</md-field>

          <!-- 积分方式 -->
					<md-field v-else>
						<div class="box-relation">
							<h2>关系证明</h2>
              <md-radio :name="1" v-model="form.guardian.relationType" label="申请人及其子女同一户籍的原籍户口簿" />
              <md-radio :name="2" v-model="form.guardian.relationType" label="子女父母双方的户口簿/结婚证/孩子出生医学证明或亲子鉴定 （能够证明其法定监护关系的其他有效证明）" />
              <md-radio :name="3" v-model="form.guardian.relationType" label="申请人的户口簿/被监护人的户口簿/司法部门出具其法定监护关系的证明（能够证明其法定监护关系的其他有效证明）" />
						</div>

						<div class="box-item">
							<h2>法定监护人（申请人）的积分信息</h2>
							<div class="text-error">
								<span>申请人的居住信息，积分达11分及以上（其中缴纳城镇职工基本养老保险得分不低于10分，合法稳定居住指标或累计居住指标不低于1分）</span>
							</div>
							<md-field-item title="是否符合" solid>
								<md-radio :name="0" v-model="form.guardian.accordType" label="是" inline />
								<md-radio :name="1" v-model="form.guardian.accordType" label="否" inline />
							</md-field-item>
						</div>

					</md-field>
				</div>
			</div>
			<div class="wrapper-body__footer">
				<div class="box-btns">
					<span class="button-primary" @touchstart="handlePreviousStep">上一步</span>
					<span class="button-primary-inset"
						@touchstart="handleNextStep">下一步</span>
				</div>
				<!-- <div><router-link :to="{path: 'bm_login', query: {signupNoticeId: $route.query.signupNoticeId}}">同意并遵守</router-link></div> -->
			</div>
		</div>
  </div>
</template>

<script>
  import IndexCommon from '../index/mixins/index_common';
  import MobileCommon from '../index/mixins/mobile_common';
  import PageForm from '../index/mixins/page_bm_form';
  import MdRadio from '../../../node_modules/mand-mobile/components/radio/index.vue';

  export default {
    mixins: [IndexCommon, MobileCommon, PageForm],
    components: { MdRadio },
    data() {
      return {
				// type: this.form.student.,

				relationChecked: '',
				certifyChecked: '',
				checked1: '',
				checked2: '',

				// 就业材料类型
				docType: '',

				// 统一社会信用代码
				companyCode: '',

				// 社保证明
				socialSecurityProve: '',

				// 是否居中满一年
				residenceOneYear: ''
			}
		},
    mounted() {
      // window.step4 = this;
      // 1. 更新formData
      this.updateFormData();
      console.log('[-> Step4] Form ::', this.form);

      // 2. 转换formData中的某些字段到当前视图中
      // todo
    },
		methods: {
			handleNextStep() {
        let { form, $message } = this;

        // 1.验证参数
        // todo
        if (this.form.student.applyType == 1) {
			if (!form.guardian.relationType) return this.$message.error('关系证明 不能为空');
	        if (!form.guardian.jobType) return this.$message.error('就业材料类型 不能为空');
	        // if (typeof form.guardian.socialSecurityProve === 'undefined') return this.$message.error('社保证明 未选择');
	        if (form.guardian.socialSecurityProve !==0 && form.guardian.socialSecurityProve !==1) return this.$message.error('社保证明 未选择');
	        if (form.guardian.socialSecurityProve === 0) return this.$message.error('抱歉，您的社保不符合条件');
	        if (!form.guardian.proofType) return this.$message.error('居住材料 不能为空');
	        if (form.guardian.jobType === 1 && !form.guardian.companyName) return this.$message.error('机构名称 不能为空');
	        if (form.guardian.jobType === 2 && !form.guardian.companyCode) return this.$message.error('统一社会信用代码 不能为空');
        } else {
			if (!form.guardian.relationType) return this.$message.error('关系证明 不能为空');
			if (form.guardian.accordType !==0 && form.guardian.accordType !==1) return this.$message.error('积分符合情况 未选择');
	        if (form.guardian.accordType === 1) return this.$message.error('抱歉，您的积分不符合条件');
        }

        // 2.转换formData格式，使数据格式和后端的保持一致（需要的才处理）
        // form[xxx] = xxx;

        // 3.保存formData到sessionStorage中
        this.saveFormData(form);

        // 4.跳转路由
				this.$router.push({
					path: 'step5_time',
					query: this.$route.query
				});
			}
		}
  }
</script>

<style lang="stylus" scoped>
	.box-sub-checked
		padding-left 40px
	.box-item
		margin-top 30px
</style>
